<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원팝업</span>
            <span class="txt">센터의 다양한 정보와 소식을 앱으로 빠르게 전달 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!popupList"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="isWriteAuth" class="com-btn blue" to="/madmin/setting/member/pop/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 1000px" />
                    <col style="width: 205px" />
                    <col style="width: 205px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>등록일</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>조회수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(popup, index) in popupList" :key="index">
                        <td>{{ popup.c_cre_dt | timestampFilter }}</td>
                        <td>
                            <router-link :to="`/madmin/setting/member/pop/detail/${popup.c_id}`" class="ic-link">
                                <span class="ic">{{ popup.c_cate_nm }}</span>
                                <span class="txt">{{ popup.c_title }}</span>
                            </router-link>
                        </td>
                        <td>{{ popup.c_cre_nm }}</td>
                        <td>{{ popup.c_view_cnt }}</td>
                    </tr>
                    <tr v-if="popupList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="isWriteAuth" class="com-btn blue" to="/madmin/setting/member/pop/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';
import {mapGetters} from 'vuex';

export default {
    name: 'SettingMemberPopList',
    props: {},
    computed: {
        ...mapGetters({
            centerId: 'auth/cId',
        }),
        isWriteAuth() {
            const {getters} = this.$store;
            return (
                getters['auth/isCareAdmin'] ||
                getters['auth/isSystemAdmin'] ||
                getters['auth/isCenterAdmin'] ||
                getters['auth/isCenterStaff']
            );
        },
        isReadAuth() {
            const {getters} = this.$store;
            return this.isWriteAuth || getters['auth/isCustomer'];
        },
    },
    mounted() {
    },
    activated() {
        this.fetchPopupList();
    },
    data() {
        return {
            popupList: null,
            pagingInfo: {...pagingInfo},
        };
    },
    methods: {
        // 팝업관리 목록 Fetch
        async fetchPopupList() {
            try {
                const {data} = await this.sendGetPopupList();
                console.log('===> Success Load Center Popup List : ', data.items);
                this.setPageParams(data);
                this.popupList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 팝업관리 목록 조회 API 호출
        sendGetPopupList() {
            // 스웨거 검색: 게시판 팝업 페이징 목록 조회
            return api.get('/admin/api/board/popup', {
                params: {
                    ...this.pagingInfo,
                    centerId: this.centerId,
                },
            });
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchPopupList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
    },
};

</script>
<style lang="scss"></style>
